import React, {
  useCallback,
  useLayoutEffect,
  useContext,
  useEffect,
} from "react";

// App styling
import "./App.scss";

// Package to listen to browser's theme
import { useBrowserThemeChangeListener } from "react-use-browser-theme";

// Global state
import { StateContext, StateDispatchContext } from "./AppStateContext";

// components imports
import Routes from "./Routes";

import { handleBrowserTheme } from "./helperFunctions";

function App() {
  // consume global state
  const setState = useContext(StateDispatchContext);
  const state = useContext(StateContext);

  //Checking browser's theme and saving it in the global state
  useLayoutEffect(() => {
    handleBrowserTheme(setState, state);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //update background color on page load
  useEffect(() => {
    let root = document.documentElement;

    if (state.theme === "light") {
      root.style.setProperty("--app-root-background-color", "#fff");
    } else {
      root.style.setProperty("--app-root-background-color", "#00152b");
    }
  }, [state.theme]);

  // Browser theme listener
  const browserThemeListener = useCallback(
    (e) =>
      setState(
        e.matches ? { ...state, theme: "dark" } : { ...state, theme: "light" }
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useBrowserThemeChangeListener(browserThemeListener);

  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
